/**
 * @email       : kpozos@ibl.mx
 * @author      : Karen Yunuen Pozos Arias
 * @title       : Full Stack Developer
 *
 */

import React from 'react';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../components/HeadTittle';
import CreateVisitorTypeApp from '../Functionality/CreateVisitorTypeApp';
import { permissionObj } from '../../../../../Helpers/permission';
import CommonCreateUpdateVisitorTypeApp from "../Functionality/CommonCreateUpdateVisitorTypeApp";
import VisitorTypeForm from "./VisitorTypeForm";
import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";

const CreateVisitorType = () => {
    const props = CommonCreateUpdateVisitorTypeApp();
    const {
        permission,
        DEV,
        emptyFields,
        item,
        fields, setFields,
        fieldData, setFieldData,
        handleChange,
        handleOnBack,
        reset
    } = props;
    const {handleCreate} = CreateVisitorTypeApp(props);

    return (
        <>
            {/* Header and title section */}
            <HeadTittle
                name={'create'}
                onBack={handleOnBack}
                divStack={
                    <ButtonIcon
                        id='btn_cvt_clean'
                        Icon={CleanIcon}
                        onClick={reset}
                        title={'clear_instances'}
                        className={"btn-clean-secondary-600"}
                        tooltipPlacement={"right"}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                }
            >
                {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_TYPE_CREATE)) && (
                    <ButtonAction
                        id='btn_vt_add_visitor'
                        name={'create'}
                        Icon={AddIcon}
                        className='btn-icon-edit'
                        onClick={handleCreate}
                    />
                )}
            </HeadTittle>

            <DivContainerBody>
                <VisitorTypeForm
                    item={item}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    fields={fields}
                    setFields={setFields}
                    fieldData={fieldData}
                    setFieldData={setFieldData}
                />
            </DivContainerBody>
        </>
    );
};
export default CreateVisitorType;
